(() => {
  'use strict';
  if (typeof HTMLDialogElement === 'undefined') return;
  let dialog;
  let image;
  let status;
  let title;
  let close;
  let original;
  let launcher;
  function createDialog() {
    dialog = document.createElement('dialog');
    dialog.className = 'bfg-design-dialog';
    dialog.setAttribute('aria-labelledby', 'bfg-design-dialog-title');
    const heading = document.createElement('div');
    heading.className = 'bfg-design-dialog__heading';
    title = document.createElement('h2');
    title.id = 'bfg-design-dialog-title';
    close = document.createElement('button');
    close.type = 'button';
    close.textContent = '×';
    close.addEventListener('click', () => dialog.close());
    heading.append(title, close);
    const content = document.createElement('div');
    content.className = 'bfg-design-dialog__content';
    status = document.createElement('p');
    status.setAttribute('role', 'status');
    image = document.createElement('img');
    image.addEventListener('load', () => {
      status.hidden = true;
      image.hidden = false;
    });
    image.addEventListener('error', () => {
      if (!dialog.open) return;
      image.hidden = true;
      status.hidden = false;
      status.textContent = launcher.dataset.previewError;
    });
    original = document.createElement('a');
    original.target = '_blank';
    original.rel = 'noopener';
    original.className = 'bfg-design-dialog__original';
    content.append(status, image, original);
    dialog.append(heading, content);
    dialog.addEventListener('close', () => {
      document.body.classList.remove('bfg-design-dialog-open');
      if (launcher?.isConnected) launcher.focus({ preventScroll: true });
    });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    });
    document.body.append(dialog);
  }
  document.addEventListener('click', event => {
    if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('a.bfg-design-preview-link');
    if (!link || !/^https?:$/.test(new URL(link.href).protocol)) return;
    event.preventDefault();
    if (!dialog) createDialog();
    launcher = link;
    title.textContent = link.dataset.previewTitle;
    close.setAttribute('aria-label', link.dataset.previewClose);
    status.textContent = link.dataset.previewLoading;
    status.hidden = false;
    image.hidden = true;
    image.alt = link.dataset.previewTitle;
    original.href = link.href;
    original.textContent = link.dataset.previewOpen;
    document.body.classList.add('bfg-design-dialog-open');
    if (!dialog.open) dialog.showModal();
    image.src = link.href;
  }, true);
})();
